<section class="container mt-5">
    <div class="row">
        <div class="col-12">
            <h1>Agregar Palcos al evento con PullEp: {{miId}}</h1>
         
        </div>

<div class="col-12">
        <form (ngSubmit)="!todoForm.invalid && agregarPalco()" #todoForm="ngForm">

        <fieldset class="form-group">
            <label for="servicio">Personas Por Palco</label>
            <input type="number" class= "form-control"name ="personasMaximo" required="required"  [(ngModel)]="palco.personasMaximas">
        </fieldset>

        <fieldset class="form-group">
            <label for="servicio">Numero Maximo de agregar el palco</label>
            <input type="text" class= "form-control"name ="numeroArriba" required="required"  [(ngModel)]="numeroArriba">
        </fieldset>

        <fieldset class="form-group">
            <label for="servicio">Numero Minimo de agregar al palco</label>
            <input type="number" class= "form-control"name ="numeroAbajo" required="required"  [(ngModel)]="numeroAbajo">
        </fieldset>

        <fieldset class="form-group">
            <label for="servicio">Tiene una letra antes del numero?</label>
            <input type="text" class= "form-control"name ="Letra"   [(ngModel)]="letra">
        </fieldset>

        
        <button class="btn btn-success" type="submit">Guardar</button>
        </form> 
    </div>
    </div>
</section>
